import React from "react";
import { Card, Row } from "antd";

import Description from "./Description";

const ProQqNew2 = ({ proinfo, title }) => {
  const data = proinfo || {};
  return (
    <Card title="产品明细">
      <h3 className="order_pro_title">{title}</h3>
      <div style={{ paddingLeft: "50px" }}>
        <Row>
          <Description term="供应商">{data.c_provider}</Description>
          <Description term="空间大小">{data.c_size}</Description>
          <Description term="类型">{data.c_spacev}</Description>
        </Row>
        <Row>
          <Description term="绑定域名">{data.c_main_domain}</Description>
          <Description term="年数">{data.c_years}</Description>
          <Description term="赠送年限">{data.c_free}</Description>
        </Row>
        <Row>
          <Description term="价格">{data.c_money}</Description>
        </Row>
      </div>
    </Card>
  );
};

export default ProQqNew2;



// WEBPACK FOOTER //
// ./src/components/xianxing/order/ProZone.js